export default __webpack_public_path__ + "static/media/fast-backward.cefc5aa6.svg";